/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { OasisTaskViewModel } from './OasisTaskViewModel'; 

export function getOasisTaskVisitBucketCategoryOptions(visitBucketId: string, categoryName: string, onSuccess?: (result: OasisTaskViewModel[]) => void) {
	return queryOptions({
		queryKey: ['oasis-task-visit-bucket-category', visitBucketId, categoryName],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/visits/queries/getoasistaskvisitbucketcategory/' + visitBucketId + '/' + categoryName;
			const resp = await axios.get<OasisTaskViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(visitBucketId) && Boolean(categoryName)
	});
}